<template>
  <div class="cords">
    <div class="left">
      <div class="cord">x</div>
      <div class="value">
        {{ loading ? "---" : Math.round(controls.position.x) }}
      </div>
    </div>
    <div>
      <div class="cord">z</div>
      <div class="value">
        {{ loading ? "---" : Math.round(controls.position.z) }}
      </div>
    </div>
    <button class="right" :disabled="loading" @click="onClickCopy">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
          stroke="#B4B4B4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
          stroke="#B4B4B4"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import { events } from "../../events";

export default {
  name: "Coordinates",
  data() {
    return {
      loading: true,
      controls: null,
    };
  },
  mounted() {
    events.on("map_loaded", this.onLoad);
  },
  methods: {
    onLoad({ bluemap }) {
      this.controls = bluemap.mapViewer.controlsManager.data;
      this.loading = false;
    },

    async onClickCopy() {
      if (this.loading) return;

      const cords = `${this.controls.position.x} ${this.controls.position.z}`;
      await navigator.clipboard.writeText(cords);
    },
  },
};
</script>

<style lang="scss">
.cord {
  font-family: "Minecraft Five";
  color: #b4b4b4;
  font-size: 16px;
}

.value {
  font-family: "Minecraft Five";
  color: white;
  font-size: 16px;

  margin-left: 20px;
}

.cords {
  border-style: solid;
  border-width: 2px;
  border-color: #18181a;

  box-sizing: border-box;

  border-radius: 15px;

  height: 50px;

  display: grid;
  grid-template-columns: 147px 147px 50px;
  gap: 2px;

  background-color: #18181a;

  .right {
    border-start-end-radius: 15px;
    border-end-end-radius: 15px;

    border: none;

    transition-timing-function: ease-out;
    transition-duration: 250ms;
    transition-property: background-color;

    &:hover {
      background-color: #262628;
      cursor: pointer;
    }

    &:disabled {
      background-color: #28282a;
      cursor: not-allowed;
    }
  }

  .left {
    border-start-start-radius: 15px;
    border-end-start-radius: 15px;
  }

  & > * {
    color: white;
    background-color: #0e0e0f;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
